import { Button, Flex, Text } from "@chakra-ui/react";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { useNavigate, useParams } from "react-router-dom";
import { UpdateProjectBlock } from "../../components/ProjectBlocks/UpdateProjectBlock/UpdateProjectBlock";
import { Layout } from "../../components/Layout/Layout";
import { RootState, useAppDispatch, useAppSelector } from "../../store";
import { useEffect } from "react";
import { fetchSingleProject, fetchUpdateProject } from "../../store/slices/projects";
import { fetchCustomers } from "../../store/slices/customers";
import { useFormik } from "formik";
import { fetchRecruiters } from "../../store/slices/vacancy";
import PageLoaderWrapper from "../../components/PageLoaderWrapper";
import { ProjectForm } from "../../model/projects";

export const UpdateProjectPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useAppDispatch();

  const { currentProject, isLoading } = useAppSelector((state: RootState) => state.projects);

  const formik = useFormik<ProjectForm>({
    initialValues: {
      name: "",
      customer_id: null,
      status: null,
      comments: "",
      description: "",
      responsible_user_id: null,
      legal_entity_id: null,
      project_format_id: null,
    },
    onSubmit: () => {},
  });

  useEffect(() => {
    dispatch(fetchSingleProject({ id: Number(id) }));
    dispatch(fetchCustomers({ params: { filters: { limit: "100000", offset: "0" } } }));
  }, [id, dispatch]);

  useEffect(() => {
    if (currentProject) {
      formik.setFieldValue("name", currentProject.name ?? "");
      formik.setFieldValue("customer_id", currentProject.customer.id ?? null);
      formik.setFieldValue("status", String(currentProject.status.id) ?? null);
      formik.setFieldValue("comments", currentProject.comments ?? "");
      formik.setFieldValue("description", currentProject.description ?? "");
      formik.setFieldValue("responsible_user_id", currentProject.responsible_user.id ?? null);
      formik.setFieldValue("legal_entity_id", currentProject.legal_entity?.id ?? null);
      formik.setFieldValue("project_format_id", currentProject.project_format?.id ?? null);
      formik.setFieldValue("contact", currentProject.contact ?? "");
      formik.setFieldValue("bitrix_project_link", currentProject.bitrix_project_link ?? "");
      formik.setFieldValue("bitrix_contract_link", currentProject.bitrix_contract_link ?? "");
      formik.setFieldValue("start_at", currentProject.start_at ?? null);
      formik.setFieldValue("planned_end_at", currentProject.planned_end_at ?? null);
    }
  }, [currentProject]);

  // Проверяем, были ли внесены изменения
  const hasChanges =
    currentProject &&
    (formik.values.name !== (currentProject.name ?? "") ||
      formik.values.customer_id !== (currentProject.customer.id ?? null) ||
      formik.values.status !== (currentProject.status.id ?? null) ||
      formik.values.comments !== (currentProject.comments ?? "") ||
      formik.values.description !== (currentProject.description ?? "") ||
      formik.values.responsible_user_id !== (currentProject.responsible_user.id ?? null) ||
      formik.values.legal_entity_id !== (currentProject.legal_entity?.id ?? null) ||
      formik.values.project_format_id !== (currentProject.project_format?.id ?? null) ||
      formik.values.contact !== (currentProject.contact ?? "") ||
      formik.values.bitrix_project_link !== (currentProject.bitrix_project_link ?? "") ||
      formik.values.bitrix_contract_link !== (currentProject.bitrix_contract_link ?? "") ||
      formik.values.start_at !== (currentProject.start_at ?? null) ||
      formik.values.planned_end_at !== (currentProject.planned_end_at ?? null));

  return (
    <Layout>
      <PageLoaderWrapper isLoading={isLoading} loadingText="Загрузка данных проекта для редактирования...">
        <Flex flexDirection="column" gap="24px" paddingRight="32px" maxH="90vh" overflowY="auto">
          <Text
            color="gray.500"
            cursor="pointer"
            onClick={() => navigate(`/projects/${currentProject?.id}`)}
            display="flex"
            alignItems="center"
            gap="8px"
          >
            <ArrowBackIcon />К проекту
          </Text>
          <Flex flexDirection="column" gap="4px">
            <Text fontSize={30} fontWeight={700} color="#3b515e">
              Редактирование проекта
            </Text>
            <Text fontSize={16} fontWeight={400} color="#65758b">
              Обновите информацию о проекте
            </Text>
          </Flex>
          <UpdateProjectBlock formik={formik} />
          <Flex gap="16px" justifyContent="flex-end">
            <Button onClick={() => navigate(-1)}>Отмена</Button>
            <Button
              bg="#2563eb"
              color="white"
              _hover={{ bg: "#2563eb" }}
              _active={{ bg: "#2563eb" }}
              onClick={() => {
                dispatch(fetchUpdateProject({ id: Number(id), body: formik.values })).then((res: any) => {
                  if (res.payload.id) {
                    currentProject && navigate(`/projects/${currentProject.id}`);
                  }
                });
              }}
              isDisabled={
                formik.values.name === "" ||
                formik.values.customer_id === null ||
                formik.values.responsible_user_id === null ||
                formik.values.status === null ||
                !hasChanges
              }
            >
              Сохранить
            </Button>
          </Flex>
        </Flex>
      </PageLoaderWrapper>
    </Layout>
  );
};
